// extracted by mini-css-extract-plugin
export default {"root":"TableNoRowsPlaceholder_root__32DG9","message":"TableNoRowsPlaceholder_message__48TBa","button":"TableNoRowsPlaceholder_button__siWFt"};